import { render, staticRenderFns } from "./JDVipshop.vue?vue&type=template&id=619571c2&scoped=true&"
import script from "./JDVipshop.vue?vue&type=script&lang=js&"
export * from "./JDVipshop.vue?vue&type=script&lang=js&"
import style0 from "./JDVipshop.vue?vue&type=style&index=0&id=619571c2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619571c2",
  null
  
)

export default component.exports